import React from "react";

function DashboardSide({ color = "#999999", width = 20, height = 20 }) {
  return (
    // <svg
    //   width={width}
    //   height={height}
    //   viewBox="0 0 25 25"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <g id="SVGRepo_bgCarrier" stroke-width="0" />
    //   <g
    //     id="SVGRepo_tracerCarrier"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />

    //   <g id="SVGRepo_iconCarrier">
    //     <path
    //       fillRule="evenodd"
    //       clipRule="evenodd"
    //       d="M9.918 10.0005H7.082C6.66587 9.99708 6.26541 10.1591 5.96873 10.4509C5.67204 10.7427 5.50343 11.1404 5.5 11.5565V17.4455C5.5077 18.3117 6.21584 19.0078 7.082 19.0005H9.918C10.3341 19.004 10.7346 18.842 11.0313 18.5502C11.328 18.2584 11.4966 17.8607 11.5 17.4445V11.5565C11.4966 11.1404 11.328 10.7427 11.0313 10.4509C10.7346 10.1591 10.3341 9.99708 9.918 10.0005Z"
    //       stroke={color}
    //       strokeWidth="1.5"
    //       strokeWinecap="round"
    //       strokeLinejoin="round"
    //     />
    //     <path
    //       fillRule="evenodd"
    //       clipRule="evenodd"
    //       d="M9.918 4.0006H7.082C6.23326 3.97706 5.52559 4.64492 5.5 5.4936V6.5076C5.52559 7.35629 6.23326 8.02415 7.082 8.0006H9.918C10.7667 8.02415 11.4744 7.35629 11.5 6.5076V5.4936C11.4744 4.64492 10.7667 3.97706 9.918 4.0006Z"
    //       stroke={color}
    //       strokeWidth="1.5"
    //       strokeWinecap="round"
    //       strokeWinejoin="round"
    //     />
    //     <path
    //       fillRule="evenodd"
    //       clipRule="evenodd"
    //       d="M15.082 13.0007H17.917C18.3333 13.0044 18.734 12.8425 19.0309 12.5507C19.3278 12.2588 19.4966 11.861 19.5 11.4447V5.55666C19.4966 5.14054 19.328 4.74282 19.0313 4.45101C18.7346 4.1592 18.3341 3.9972 17.918 4.00066H15.082C14.6659 3.9972 14.2654 4.1592 13.9687 4.45101C13.672 4.74282 13.5034 5.14054 13.5 5.55666V11.4447C13.5034 11.8608 13.672 12.2585 13.9687 12.5503C14.2654 12.8421 14.6659 13.0041 15.082 13.0007Z"
    //       stroke={color}
    //       strokeWidth="1.5"
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //     />
    //     <path
    //       fillRule="evenodd"
    //       clipRule="evenodd"
    //       d="M15.082 19.0006H17.917C18.7661 19.0247 19.4744 18.3567 19.5 17.5076V16.4936C19.4744 15.6449 18.7667 14.9771 17.918 15.0006H15.082C14.2333 14.9771 13.5256 15.6449 13.5 16.4936V17.5066C13.525 18.3557 14.2329 19.0241 15.082 19.0006Z"
    //       stroke={color}
    //       strokeWidth="1.5"
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //     />
    //   </g>
    // </svg>
//     <svg
//   xmlns="http://www.w3.org/2000/svg"
//   viewBox="0 0 64 64"
//   fill="none"
//   stroke={color}
//   stroke-width="2"
//   stroke-linecap="round"
//   stroke-linejoin="round"
//   class="w-5 h-5"
// >
//   {/* <!-- Outer Frame --> */}
//   <rect x="2" y="2" width="60" height="60" rx="8" ry="8" fill="none" stroke={color}/>

//   {/* <!-- Speedometer (Gauge) --> */}
//   <g transform="translate(16, 20)">
//     {/* <!-- Gauge Circle --> */}
//     <circle cx="1" cy="0" r="12" fill="none" stroke='#1F509A'/>
    
//     {/* <!-- Gauge Ticks --> */}
//     <line x1="0" y1="-12" x2="0" y2="-10" stroke='#1F509A'/>
//     <line x1="10.39" y1="-6.0" x2="9.39" y2="-5.0" stroke='#1F509A'/>
//     <line x1="10.39" y1="6.0" x2="9.39" y2="5.0" stroke='#1F509A'/>
//     <line x1="0" y1="12" x2="0" y2="10" stroke='#1F509A'/>
//     <line x1="-10.39" y1="6.0" x2="-9.39" y2="5.0" stroke='#1F509A'/>
//     <line x1="-10.39" y1="-6.0" x2="-9.39" y2="-5.0" stroke='#1F509A'/>
    
//     {/* <!-- Gauge Needle --> */}
//     <line x1="0" y1="0" x2="8" y2="-8" stroke={color} stroke-width="2"/>
    
//     {/* <!-- Center Dot --> */}
//     <circle cx="0" cy="0" r="2" fill={color} />
//   </g>

//   {/* <!-- Bar Charts --> */}
//   <g transform="translate(40, 20)">
//     {/* <!-- First Bar --> */}
//     <rect x="-8" y="8" width="4" height="20" fill='#D91656' stroke="none"/>
//     {/* <!-- Second Bar --> */}
//     <rect x="0" y="4" width="4" height="24" fill='#D91656' stroke="none"/>
//     {/* <!-- Third Bar --> */}
//     <rect x="8" y="0" width="4" height="28" fill='#D91656' stroke="none"/>
//   </g>

//   {/* <!-- Bulleted List --> */}
//   <g transform="translate(16, 44)">
//     {/* <!-- Bullet Points --> */}
//     <circle cx="0" cy="0" r="2" fill='#0000'/>
//     <circle cx="0" cy="8" r="2" fill='#0000'/>
//     <circle cx="0" cy="16" r="2" fill='#0000'/>
    
//     {/* <!-- Lines --> */}
//     <line x1="4" y1="0" x2="20" y2="0" stroke='#AE445A'/>
//     <line x1="4" y1="8" x2="20" y2="8" stroke='#AE445A'/>
//     <line x1="4" y1="16" x2="20" y2="16" stroke='#AE445A'/>
//   </g>
// </svg>
<svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 200 200" fill="none">
  {/* <!-- Circle for Speedometer --> */}
  <circle cx="100" cy="100" r="60" stroke="#999999" stroke-width="8" fill="none" />
  {/* <!-- Needle for Speedometer --> */}
  <line x1="100" y1="100" x2="140" y2="100" stroke="#999999" stroke-width="4" stroke-linecap="round" />
  {/* <!-- Speedometer Notches --> */}
  <line x1="100" y1="40" x2="100" y2="50" stroke="#999999" stroke-width="3" />
  <line x1="138.28" y1="61.72" x2="132.28" y2="67.72" stroke="#999999" stroke-width="3" />
  <line x1="160" y1="100" x2="150" y2="100" stroke="#999999" stroke-width="3" />

  {/* <!-- Bar Chart --> */}
  <rect x="50" y="120" width="20" height="50" fill="#999999" />
  <rect x="80" y="100" width="20" height="70" fill="#999999" />
  <rect x="110" y="140" width="20" height="30" fill="#999999" />

  {/* <!-- Line Graph --> */}
  <path d="M50 160 L80 140 L110 110 L140 130" stroke="#999999" stroke-width="3" fill="none" />
  <circle cx="50" cy="160" r="3" fill="#999999" />
  <circle cx="80" cy="140" r="3" fill="#999999" />
  <circle cx="110" cy="110" r="3" fill="#999999" />
  <circle cx="140" cy="130" r="3" fill="#999999" />
</svg>



  

  );
}

export default DashboardSide;
